module.exports = __webpack_public_path__ + "static/media/component-friend-card.c7cd8d68.png";